var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_interface_delete",
    width: 16.599,
    height: 18.673,
    viewBox: "0 0 16.599 18.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48",
    d: "M10.619,24.673a1.55,1.55,0,0,1-1.556-1.556V8.334H8V6.778h4.876V6h6.847v.778H24.6V8.334H23.535V23.117a1.6,1.6,0,0,1-1.556,1.556ZM21.979,8.334H10.619V23.117h11.36ZM13.369,20.887h1.556V10.539H13.369Zm4.305,0H19.23V10.539H17.674ZM10.619,8.334v0Z",
    transform: "translate(-8 -6)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a6d15455bf391d9d934a15e18313feda.svg";
export { ForwardRef as ReactComponent };